module.exports = __webpack_public_path__ + "static/img/ambulatilis.88e81bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/projects/ambulatilis.jpg
// module id = tbit
// module chunks = 0